export default __webpack_public_path__ + "static/media/hk.6d65bd9f.svg";